import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  disconnectQbo,
  fetchQboStatus,
  fetchQboSyncLog,
  qboCallback,
  startQboConnect,
  syncQboNow,
} from './api'

export const QBO_STATUS_KEY = ['quickbooks-status'] as const
export const QBO_SYNC_LOG_KEY = ['quickbooks-sync-log'] as const

const invalidateAll = (qc: ReturnType<typeof useQueryClient>) => {
  void qc.invalidateQueries({ queryKey: QBO_STATUS_KEY })
  void qc.invalidateQueries({ queryKey: QBO_SYNC_LOG_KEY })
}

export const useQboStatus = () => useQuery({ queryKey: QBO_STATUS_KEY, queryFn: fetchQboStatus })

export const useQboSyncLog = () =>
  useQuery({ queryKey: QBO_SYNC_LOG_KEY, queryFn: fetchQboSyncLog })

export const useStartQboConnect = () => useMutation({ mutationFn: startQboConnect })

export const useQboCallback = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ code, state, realmId }: { code: string; state: string; realmId: string }) =>
      qboCallback(code, state, realmId),
    onSuccess: (_data, _vars) => invalidateAll(qc),
  })
}

export const useDisconnectQbo = () => {
  const qc = useQueryClient()
  return useMutation({ mutationFn: disconnectQbo, onSuccess: (_d, _v) => invalidateAll(qc) })
}

export const useSyncQboNow = () => {
  const qc = useQueryClient()
  return useMutation({ mutationFn: syncQboNow, onSuccess: (_d, _v) => invalidateAll(qc) })
}
